
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const DeviceNotFound = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Device Details</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex justify-center items-center h-40">
          <p className="text-muted-foreground">Device not found</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default DeviceNotFound;
